import { Directive, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';

declare const google: any;

@Directive({
	selector: '[appGoogleSearch]'
})
export class GoogleSearchDirective implements OnInit {
	@Input() public dataToPassThrough: any;
	public inputElement: any;
	@Input() public onPlaceFound: Function;
	@Output() public selectedAddress = new EventEmitter<Object>();

	constructor(public el: ElementRef) {
		this.inputElement = el.nativeElement;
	}

	handleAddressKeyboardSelection(event) {
		// This listens for tab or enter and then triggers selection of the first result from google places
		if (this.inputElement.value.length > 0 && (event.keyCode === 9 || event.keyCode === 13)) {
			const selected = document.getElementsByClassName('pac-item-selected');
			if (selected?.length === 0) {
				const ex1: any = new Event('keydown');
				ex1.code = 'ArrowDown';
				ex1.key = 'ArrowDown';
				ex1.keyCode = 40;
				google.maps.event.trigger(event.target, 'keydown', ex1);
			}

			const ex2: any = new Event('keydown');
			ex2.code = 'Enter';
			ex2.key = 'Enter';
			ex2.keyCode = 13;
			ex2.triggered = true;
			google.maps.event.trigger(event.target, 'keydown', ex2);
		}
	}

	ngOnInit() {
		const autocompleteInput = new google.maps.places.Autocomplete(this.inputElement, {});
		autocompleteInput.setFields(['name', 'address_component', 'geometry']);
		google.maps.event.addListener(autocompleteInput, 'place_changed', () => {
			const place = autocompleteInput.getPlace();
			this.selectedAddress.emit(place);
		});

		this.inputElement.addEventListener('keydown', event => {
			this.handleAddressKeyboardSelection(event);
		});
	}
}
